// extracted by mini-css-extract-plugin
export default {"normalIcon":"icon_normalIcon__aIUVP","activeIcon":"icon_activeIcon__mAto5"};